export default __webpack_public_path__ + "static/media/imgPerfilCardico.45b2d72e.png";